import { TextBase } from '@carboncopyco/ui';
import { Screenshot } from '../../Screenshot';

interface ActivityExternalDescriptionProps {
  image: string;
  title: string;
  description?: string;
  onClick: () => void;
  isOverlayDemo?: boolean;
}

const ActivityExternalDescription = ({
  image,
  title,
  description,
  onClick,
  isOverlayDemo,
}: ActivityExternalDescriptionProps) => (
  <div className="py-2 flex items-center">
    <div className="flex flex-shrink-0">
      <div onClick={onClick}>
        <div className="w-20 h-12">
          <Screenshot
            image={image}
            rounded="sm"
            isOverlayDemo={isOverlayDemo}
          />
        </div>
      </div>
    </div>
    <div className="pl-4 flex flex-col">
      <div onClick={onClick}>
        <div className="w-75">
          <TextBase
            label={title}
            color="text-ds-natural-600"
          />
        </div>
      </div>
      {description && (
        <div className="w-75 ">
          <TextBase
            label={description}
            color="text-ds-natural-300"
          />
        </div>
      )}
    </div>
  </div>
);

export default ActivityExternalDescription;
